import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { LocationResolverLocationSelected } from '../stores/locations/locations.actions';

@Injectable({ providedIn: 'root' })
export class LocationResolverService {
  private readonly store = inject(Store);

  resolve(route: ActivatedRouteSnapshot): boolean {
    this.store.dispatch(
      new LocationResolverLocationSelected({
        HotelCode: route.params.location,
      })
    );

    return true;
  }
}
